module.exports = __webpack_public_path__ + "img/can10.deb38f54.png";